/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDownFromDoubleLine: {
  name: 'arrow-down-from-double-line';
  data: string;
} = {
  name: 'arrow-down-from-double-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm7 4h4a1 1 0 1 0 0-2H7a1 1 0 0 0 0 2h4v7.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L13 16.586V9Z" fill="currentColor"/></svg>`,
};
